import axios from 'axios';

export async function obtdatos(values) {
  let source=axios.CancelToken.source();
  try 
  {
    let formData = new FormData();
    const elems=Object.keys(values);
    elems.forEach(item => {if (values[item] !== undefined) { formData.append(item, values[item])}});
/*
    console.log('ENTRADA');
    console.log(values);
    console.log("Lista de elementos enviados");
    for (var pair of formData.entries()) {
    console.log(pair[0]+ '=' + pair[1]); }
*/
    const response = await axios ({
        url:'https://estadisticas.setab.gob.mx/controles/ctrlcedest.php',
        //url:'http://localhost:8010/estadistica/controles/ctrlcedest.php',
        method: 'post',
        cancelToken:source.token,
        data:formData,
        headers: {'Content-Type': 'application/json; charset=utf-8'}
    })
    return response;
  } catch (error) {
      if (axios.isCancel(error)) {
        console.log("caught cancel");
      } else {
         // throw error;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
      }
  }
}



export async function obtcicloestad() {
  let source=axios.CancelToken.source();
  try 
  { 
    let formData = new FormData();
    const response = await axios ({
        url:'https://estadisticas.setab.gob.mx/controles/obtcicloestad.php',
        //url:'http://localhost:8010/estadistica/controles/obtcicloestad.php',
        method: 'post',
        cancelToken:source.token,
        data:formData,
        headers: {'Content-Type': 'application/json; charset=utf-8'}
    })
    return response;
  } catch (error) {
      if (axios.isCancel(error)) {
        console.log("caught cancel");
      } else {
         // throw error;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
      }
  }
}